"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _WrapperVariantContext = require("./WrapperVariantContext");

var _PickersModalDialog = _interopRequireDefault(require("../PickersModalDialog"));

var _jsxRuntime = require("react/jsx-runtime");

function MobileWrapper(props) {
  const {
    cancelText,
    children,
    clearable,
    clearText,
    DateInputProps,
    DialogProps,
    okText,
    onAccept,
    onClear,
    onDismiss,
    onSetToday,
    open,
    PureDateInputComponent,
    showTodayButton,
    todayText
  } = props,
        other = (0, _objectWithoutPropertiesLoose2.default)(props, ["cancelText", "children", "clearable", "clearText", "DateInputProps", "DialogProps", "okText", "onAccept", "onClear", "onDismiss", "onSetToday", "open", "PureDateInputComponent", "showTodayButton", "todayText"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_WrapperVariantContext.WrapperVariantContext.Provider, {
    value: "mobile",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PureDateInputComponent, (0, _extends2.default)({}, other, DateInputProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickersModalDialog.default, {
      cancelText: cancelText,
      clearable: clearable,
      clearText: clearText,
      DialogProps: DialogProps,
      okText: okText,
      onAccept: onAccept,
      onClear: onClear,
      onDismiss: onDismiss,
      onSetToday: onSetToday,
      open: open,
      showTodayButton: showTodayButton,
      todayText: todayText,
      children: children
    })]
  });
}

var _default = MobileWrapper;
exports.default = _default;